import RootState from 'constants/RootState';
import { createSelector } from 'reselect';
import { Props } from '../components/Layout';
import { get } from 'lodash';
import { nucleusLocaleToStandard } from 'assets/locales/nucleusLocaleMappings';

const getCurrentLocale = (state: RootState) => get(nucleusLocaleToStandard, state.nucleus.localization.localeCode, 'en-US');

const appSelector = createSelector([getCurrentLocale],
  (currentLocale: string) => {
    return {
      currentLocale,
    } as Props;
  });

export default appSelector;



// WEBPACK FOOTER //
// ./src/selectors/app.ts